var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-simple-search',{attrs:{"placeholder":_vm.placeholder,"search_symbol":true,"show_tooltip":true,"tooltip_message":"search symbol"}})}
var staticRenderFns = []

export { render, staticRenderFns }